var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"donut-grafico"}},[(_vm.configuracoes)?_c('DonutGrafico',{ref:"donutChart",attrs:{"type":"donut","height":_vm.height,"options":_vm.options,"series":_vm.series}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }